import { mapState, mapActions } from 'vuex';

import { ESTADOS, STATUS_IMOVEL } from '../../util/constantes';
import funcoes from '../../util/funcoes';

import AppSelecionarAdministradoraDialog from './dialogs/SelecionarAdministradoraDialog.vue';

export default {
  components: {
    AppSelecionarAdministradoraDialog
  },
  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ],
        endereco: [
          { required: true, message: "Nome é obrigatório" }
        ],
        cidade: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        estado: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        bairro: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        cep: [
          { required: true, message: "Nome é obrigatório" }
        ]
      },
      loadingCidades: false,
      cidadesDisponiveis: [],
      bairrosDisponiveis: [],
      loadingBairros: false,
      visibilidadeSelecionarAdministradoraDialog: false,
      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    };
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes.filter((permissao) => {
          return permissao.modulo === "CONDOMINIOS";
        })[0];
      }
    }),
    ...mapState('condominiosStore', {
      condominios(state) { return state.listaCondominios; },
      condominioPesquisa(state) { return state.condominioPesquisa; },
      labelQuantidade(state) { return state.labelQuantidade; },
      condominio(state) { return state.condominioSelecionado; }
    }),
    estados() { return ESTADOS.filter(estado => { return estado.pais.id === 1 }); },
    exibirCondominios() {
      return this.permissoes.visualizacao;
    },
    exibirBotaoGravarCondominio() {
      return (
        (this.condominio.id === 0 && this.permissoes.cadastro)
        || (this.condominio.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverCondominio() { return this.condominio.id != 0 && this.permissoes.remocao; },
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('condominiosStore', [
      'pesquisarCondominios',
      'limparCondominiosListados',
      'limparCondominioPesquisa',
      'recuperarCondominio',
      'novoCondominio',
      'gravarCondominio',
      'removerCondominio',
      'limparAdministradoraSelecionada',
      'limparCidadeEBairro'
    ]),
    ...mapActions('administradorasStore', [
      'listarAdministradoras'
    ]),
    ...mapActions('cidadesStore', [
      'listarCidades'
    ]),
    ...mapActions('bairrosStore', [
      'listarBairros'
    ]),
    exibirSelecionarAdministradoraDialog() {
      this.visibilidadeSelecionarAdministradoraDialog = true;
    },
    fecharSelecionarAdministradoraDialog() {
      this.visibilidadeSelecionarAdministradoraDialog = false;
    },
    limparCidadesDisponiveis() {
      this.cidadesDisponiveis = [];
    },
    limparBairrosDisponiveis() {
      this.bairrosDisponiveis = [];
    },
    pesquisar($state) {
      if(this.condominioPesquisa.pagina === 0) { this.showLoading(); }
      this.pesquisarCondominios(this.condominioPesquisa)
        .then((resultado) => {
          if(this.condominioPesquisa.pagina === 0) { this.hideLoading(); }

          if(resultado.lista.length == 100) {
            this.condominioPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.condominioPesquisa.pagina == 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.condominioPesquisa.pagina === 0) { this.hideLoading(); }
          this.$message("Não foi possível conectar-se ao servidor");
        });
    },
    pesquisarHandler() {
      this.condominioPesquisa.pagina = 0;
      this.limparCondominiosListados();
      this.infiniteLoadingId += 1;
    },
    novoCondominioHandler() {
      this.$refs["formCondominio"].resetFields();
      this.novoCondominio();
    },
    limparPesquisa() {
      this.limparCondominioPesquisa();
    },
    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },
    recuperarHandler(condominio) {
      this.recuperar(condominio);
    },
    recuperar(condominio) {
      this.showLoading();
      this.recuperarCondominio(condominio).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['formCondominio'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarCondominio(this.condominio).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerCondominioHandler() {
      this.$confirm("Deseja realmente remover este Condomínio?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        if(this.condominio.imoveis.length > 0){
          this.$message.warning("O condomínio possui imóveis cadastrados! Não é possível removê-lo.");
        }else { this.remover(); }
      });
    },
    remover() {
      this.showLoading();
      this.removerCondominio(this.condominio).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparEstadoHandler() {
      this.limparCidadeEBairro();
      this.limparCidadesDisponiveis();
      this.limparBairrosDisponiveis();
    },
    selecaoEstadoHandler(estado) {
      this.limparCidadeEBairro();
      this.limparBairrosDisponiveis();
      if(!estado) { return }

      this.showLoading();

      let payload = { estado: { id: estado.id } }
      this.listarCidades(payload)
        .then((resultado) => {
          this.hideLoading();
          this.cidadesDisponiveis = (resultado.status === "SUCESSO" ? resultado.lista : []);
        }).catch(() => {
          this.hideLoading();
        });
    },
    recuperarCidadesSelect(queryString) {
      if(this.condominio.estado.id === 0) {
        if(queryString !== '') {
          this.$message.warning("Selecione o estado");
        }
        return;
      }
      let payload = { nome: queryString, estado: { id: this.condominio.estado.id } };
      this.loadingCidades = true;

      this.listarCidades(payload).then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = resultado.status === "SUCESSO" ? resultado.lista : [];
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    selecaoCidadeHandler(cidade) {
      if(!cidade) { return }

      this.showLoading();

      let payload = { cidade: { id: cidade.id } };
      this.listarBairros(payload)
        .then((resultado) => {
          this.hideLoading();
          this.bairrosDisponiveis = resultado.status === "SUCESSO" ? resultado.lista : [];
        }).catch(() => {
          this.hideLoading();
        });
    },
    recuperarBairrosSelect(queryString) {
      if(this.condominio.cidade.id === 0) {
        if(queryString !== '') {
          this.$message.warning("Selecione a Cidade");
        }
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.condominio.cidade.id } };
      this.loadingBairros = true;

      this.listarBairros(payload).then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status === "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    getLabelStatusImovel(item) {
      return funcoes.getLabel(STATUS_IMOVEL, item.status);
    }
  }
}